import {
    Component,
    OnInit,
    OnDestroy,
    ViewChild,
    ViewContainerRef
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Modal } from "angular2-modal/plugins/bootstrap";
import { SignaturePad } from "angular2-signaturepad/signature-pad";
import { ToastrService } from "ngx-toastr";
import { Subscription } from "rxjs";
import { EchexbaseComponent } from "../echexbase/echexbase.component";

import { NgForm } from "@angular/forms";
import { Constants } from "../app.constants";
import { AutologoutService } from "../autologout.service";
import { EchexpaymentService } from "../echexpayment.service";
import { LocalstorageService } from "../localstorage.service";
import { ScriptService } from "../script.service";
import { UserService } from "../user.service";
import { ElementRef, Renderer2, QueryList, ViewChildren } from "@angular/core";
declare var Plaid: any;

@Component({
    selector: "echexpayment-profile",
    templateUrl: "./profile.component.html",
    styleUrls: ["./profile.component.css"]
})
export class ProfileComponent extends EchexbaseComponent
    implements OnInit, OnDestroy {
    @ViewChild("iu") iu: NgForm;
    @ViewChild("f") profileUpdates: NgForm;
    profileSettings: any = {};
    inviteUser: any = {};
    profileBankDetails: any = {};
    profile: any = {};
    vendor_img: any = {};
    public mask: Array<string | RegExp>;
    public token: string;
    public user_id: string;
    public role_id: string;
    public dataNotFound: boolean = false;
    public TeamdataNotFound: boolean = false;
    public settings: {};
    public permissions: {};
    public plaid_link_token: string;
    //twofactor
    public imageurl: string;

    public secret_key: string;
    username: string = "";

    public noFooter: boolean = true;

    public width: number = 200;
    public height: number = 200;
    busy: Subscription;

    //bank details show edit button
    public show_edit_signature: boolean = false;
    public hide_signature_tab: boolean = true;

    public draw_it: boolean = false;
    public type_it: boolean = false;

    public profileTab: string;
    public teamMemberTab: boolean = false;
    public settingsTab: boolean = false;
    public bankDetailsTab: boolean = false;
    //Validation
    public invalidEmalAddress: boolean = false;
    public signature_validation: boolean = false;
    public val_type_signature: boolean = false;
    public signature_clear: boolean = false;
    public signature_submit: boolean = false;

    //profile update
    public validationFirstname: boolean = false;
    public validationLastname: boolean = false;
    public validationBusinessname: boolean = false;
    public validationIndustrytype: boolean = false;
    public validationEmail: boolean = false;
    public invalidEmail: boolean = false;
    public inviteEmail: boolean = false;
    public validationPhone: boolean = false;
    public validationPassword: boolean = false;
    public validationConfirmpassword: boolean = false;
    public match: boolean = false;
    public minPassword: boolean = false;
    public validationWebsite: boolean = false;
    public validationAccountNumber: boolean = false;
    public validationAccountNumberLength: boolean = false;
    public validationRoutingNo_Length: boolean = false;
    public validationRoutingNumber: boolean = false;
    public validationCountry_code: boolean = false;

    public twofactorStatus: boolean;
    public merchantUsers: {};
    public merchantId: string;
    public merchantImg_url: string;
    public selectedImage: string;
    public VendorImage: string;
    public getDoc_List: any = [];
    public doc_dataNotFound: boolean = false;
    public invoiceDataNotFound: boolean = false;
    public chequeerror_res: string;
    public imageValidate: boolean = false;
    public vendorimgValidate: boolean = false;
    public recurringInvoiceList: any = [];
    linkHandler: any;
    public tokenj: string;
    public bankzip: string;
    public plaid_public_key: string;
    public key: string;
    public plaid_public_token: string;
    public ptoken: any = {};
    public account_checking: string;
    public routing_checking: string;
    public disable: boolean = false;
    public twofactorenable: boolean = false;
    public bankname: string;
    public upermissions: any = {};

    // Direct deposit variable
    public showAutomaticOption: boolean = false;
    public directDepositOption: string ='manual';
    public automaticTypeOption: string = 'standard_ach';

    public user_permissions = [
        // { value: 'ViewCheck', display: 'View Check' },
        { value: "PrintCheck", display: "Print Check" },
        { value: "CreateCheque", display: "Create Check" }
    ];
    public formTouched: boolean = false;
    public PhoneOtpcheck: string;

    @ViewChild(SignaturePad) signaturePad: SignaturePad;

    private signaturePadOptions: Object = {
        // passed through to szimek/signature_pad constructor
        minWidth: 2,
        canvasWidth: 200,
        canvasHeight: 200
    };

    //recuring
    public data;
    public filterQuery = "";
    public rowsOnPage = 50;
    public sortBy = "";
    public sortByRecurring = "created_at";
    public sortOrder = "DESC";
    NamecharacterLimitReached: { [key: string]: boolean } = {};
    isDialogOpen: boolean = false;
    isOTPForm: boolean = false;
    public CheckOtp: boolean = false;
    public confirmPhoneField: boolean = false;
    public phoneNumber: string;

    constructor(
        protected route: ActivatedRoute,
        private elementRef: ElementRef,
        private renderer: Renderer2,
        private CONSTANTS: Constants,
        private scriptService: ScriptService,
        protected router: Router,
        protected toastr: ToastrService,
        protected userService: UserService,
        protected echexpaymentService: EchexpaymentService,
        vcRef: ViewContainerRef,
        public modal: Modal,
        protected localStorageService: LocalstorageService,
        public autologout: AutologoutService
    ) {
        super(
            route,
            router,
            toastr,
            userService,
            echexpaymentService,
            localStorageService
        );
        this.mask = [
            "(",
            /[1-9]/,
            /\d/,
            /\d/,
            ")",
            " ",
            /\d/,
            /\d/,
            /\d/,
            "-",
            /\d/,
            /\d/,
            /\d/,
            /\d/
        ];
        this.router = router;
        var currentUser = this.localStorageService.getData("currentUserToken");
        this.token = currentUser.data.user_token;
        let userDetails = <any>{};
        let permissions = <any>{};
        userDetails = this.localStorageService.getData("currentUser");
        this.merchantId = userDetails.merchant_token;
        this.selectedImage = userDetails && userDetails.image_url;
        this.VendorImage = userDetails && userDetails.business_image_url;
        this.user_id = userDetails._id;

        permissions = userDetails.settings;
        this.role_id = userDetails.role_id;
        //auto logout
        autologout.reset();

        this.plaid_public_key = CONSTANTS.plaid_public_key;
        this.key = CONSTANTS.captcha_key;

        if (this.role_id == "3") {
            if (permissions.permissions["Profile"] == "yes") {
                this.profileTab = permissions.permissions["Profile"];
            }
            if (permissions.permissions["TeamMember"] == "yes") {
                this.teamMemberTab = permissions.permissions["TeamMember"];
            }
            if (permissions.permissions["BankDetails"] == "yes") {
                this.settingsTab = permissions.permissions["BankDetails"];
            }
            if (permissions.permissions["Settings"] == "yes") {
                this.bankDetailsTab = permissions.permissions["Settings"];
            }
        }
        this.twofactorStatus = true;
    }

    ngOnDestroy() {
        this.toastr.clear();
    }

    ngOnInit() {
        this.getprofileDetails();

        // this.getDocument_List();
        if (this.role_id == "3") {
            // this.getMerchantUsers();
            this.getAllTransaction();
        }
    }
    @ViewChildren("checkboxRefs") checkboxRefs: QueryList<ElementRef>;
    focusFirstCheckbox() {
        const firstCheckbox = this.checkboxRefs.first;
        if (firstCheckbox && firstCheckbox.nativeElement) {
            firstCheckbox.nativeElement.focus();
        }
    }

    handleTabClick(tabTitle: string) {
        if (tabTitle === "User Management") {
            this.getMerchantUsers();
            setTimeout(() => {
                const businessNameElement = document.querySelector(
                    "#Userpage_name"
                ) as HTMLInputElement;
                if (businessNameElement) {
                    this.renderer
                        .selectRootElement(businessNameElement)
                        .focus();
                }
            }, 0);
        }
        if (tabTitle === "Document Details") {
            this.getDocument_List();
        }
        if (tabTitle === "Invoice Recurring") {
            this.getInvoice_List();
        }
        if (tabTitle === "Merchant Profile") {
            setTimeout(() => {
                const businessNameElement = document.querySelector(
                    "#Business_name"
                ) as HTMLInputElement;
                if (businessNameElement) {
                    this.renderer
                        .selectRootElement(businessNameElement)
                        .focus();
                }
            }, 0);
        }

        if (tabTitle === "Recurring") {
            this.getAllTransaction();
        }

        if (tabTitle === "Merchant User Profile") {
            setTimeout(() => {
                const businessNameElement = document.querySelector(
                    "#mfirst_name"
                ) as HTMLInputElement;
                if (businessNameElement) {
                    this.renderer
                        .selectRootElement(businessNameElement)
                        .focus();
                }
            }, 0);
        }

        if (tabTitle === "Direct Deposit") {
            // Direct deposit
            var currentUser = this.localStorageService.getData("currentUserToken");
            
            if(currentUser && currentUser.data.settings.direct_deposit_settings) {
                var deposit_settings = currentUser.data.settings.direct_deposit_settings;
                this.directDepositOption = deposit_settings.deposit_type;
                this.automaticTypeOption = deposit_settings.deposit_type_settings;

                if(deposit_settings.deposit_type == 'automatic') {
                    this.showAutomaticOption = true;
                }
            }
        }
    }

    focusNextCheckbox(index: number) {
        const nextIndex = index + 1;
        if (nextIndex < this.checkboxRefs.length) {
            const nextCheckbox = this.checkboxRefs.toArray()[nextIndex];
            if (nextCheckbox && nextCheckbox.nativeElement) {
                nextCheckbox.nativeElement.focus();
            }
        } else {
            const saveButton = document.getElementById(
                "saveButton"
            ) as HTMLElement;
            if (saveButton) {
                saveButton.focus();
                saveButton.click();
            }
        }
    }

    drawComplete() {
        this.signature_clear = true;
        this.signature_submit = true;
    }

    drawStart() {
        this.signature_validation = false;
    }

    public clear() {
        this.signature_clear = false;
        this.signature_submit = false;
        this.signaturePad.clear();

        //this.signature = '';
    }

    eventHandler() {
        this.invalidEmalAddress = false;
        this.signature_validation = false;
        this.val_type_signature = false;
        this.validationFirstname = false;
        this.validationLastname = false;
        this.validationPassword = false;
        this.validationBusinessname = false;
        this.validationIndustrytype = false;
        this.validationEmail = false;
        this.inviteEmail = false;
        this.invalidEmail = false;
        this.validationPhone = false;
        this.validationPassword = false;
        this.validationConfirmpassword = false;
        this.match = false;
        this.minPassword = false;
        this.validationWebsite = false;
        this.validationAccountNumber = false;
        this.validationRoutingNumber = false;
        this.validationCountry_code = false;
        this.validationAccountNumberLength = false;
        this.validationRoutingNo_Length = false;
    }

    fileToUpload: File = null;
    handleFileInput(files: FileList) {
        if (files.length === 0) {
            return;
        }

        const allowedFileTypes = ["image/jpeg", "image/png"];
        const file = files[0];
        if (!allowedFileTypes.includes(file.type)) {
            this.imageValidate = true;
            return;
        } else {
            this.imageValidate = false;
        }
        this.fileToUpload = files.item(0);
        const reader = new FileReader();
        reader.onload = () => {
            this.selectedImage = reader.result as string;
        };
        reader.readAsDataURL(files[0]);
    }

    vendorlogoUpload: File = null;
    vendorlogo(files: FileList) {
        if (files.length === 0) {
            return;
        }

        const allowedFileTypes = ["image/jpeg", "image/png"];
        const file = files[0];
        if (!allowedFileTypes.includes(file.type)) {
            this.vendorimgValidate = true;
            return;
        } else {
            this.vendorimgValidate = false;
        }
        this.vendorlogoUpload = files.item(0);
        const reader = new FileReader();
        reader.onload = () => {
            this.VendorImage = reader.result as string;
        };
        reader.readAsDataURL(files[0]);
    }

    DisallowZero(event: any) {
        const allowedKeys = ["Backspace", "Delete", "Tab", "Escape", "Enter"];
        const allowedKeyCodes = [46, 8, 9, 27, 13]; // Backspace, Delete, Tab, Escape, Enter

        if (
            allowedKeys.indexOf(event.key) !== -1 ||
            allowedKeyCodes.indexOf(event.keyCode) !== -1
        ) {
            // Allow the default behavior for certain keys
            return;
        }

        const inputValue = event.target.value;
        const caretStart = event.target.selectionStart;
        const caretEnd = event.target.selectionEnd;
        const modifiedValue =
            inputValue.slice(0, caretStart) +
            event.key +
            inputValue.slice(caretEnd);

        if (modifiedValue.length === 1 && modifiedValue.charAt(0) === "0") {
            // Prevent input of '0' as the first digit
            event.preventDefault();
            return;
        }

        if (!/^\d+(\.\d{0,2})?$/.test(modifiedValue)) {
            event.preventDefault();
        }
    }

    VendorImageUpload(data) {
        data.token = this.merchantId;
        const formData = new FormData();

        formData.append("photo", this.fileToUpload, this.fileToUpload.name);

        Object.entries(data).forEach(([key, value]) => {
            formData.append(key, value as any);
        });

        data.user_token = this.token;
        data.id = this.merchantId;
        let updateProfileData = <any>{};
        this.busy = this.userService
            .VendorImageUpload(data, formData)
            .subscribe(
                response => {
                    updateProfileData = response;

                    this.localStorageService.setData(
                        "Profile_image",
                        updateProfileData.data.image_url
                    );
                    this.merchantImg_url =
                        updateProfileData.data.business_image_url;
                    this.toastr.success(updateProfileData.message, "Success!");
                    this.getprofileDetails();
                },
                error => {
                    updateProfileData = error;
                    this.toastr.error(
                        updateProfileData.error.message,
                        "Failed!"
                    );
                }
            );
    }

    //update profile
    updateProfile(data) {
        this.focusFirstInvalidControlPlus(); //focus field
        if (data.valid) {
            let model: any = data.value;
            model.id = this.user_id;
            model.token = this.user_id;
            model.user_token = this.token;

            const formData = new FormData();
            if (this.fileToUpload) {
                formData.append(
                    "photo",
                    this.fileToUpload,
                    this.fileToUpload.name
                );
            }
            // Image validation
            if (this.imageValidate === true) {
                return;
            }
            if (this.vendorimgValidate === true) {
                return;
            }
            if (this.vendorlogoUpload) {
                formData.append(
                    "vendor_logo",
                    this.vendorlogoUpload,
                    this.vendorlogoUpload.name
                );
            }

            Object.entries(model).forEach(([key, value]) => {
                formData.append(key, value as any);
            });

            let updateProfileData = <any>{};
            this.busy = this.userService
                .updateProfile(model, formData)
                .subscribe(
                    response => {
                        updateProfileData = response;

                        let data = { data: { user_token: this.token } };
                        this.userService
                            .getAuthUser(data)
                            .subscribe(response => {
                                updateProfileData = response;
                                this.localStorageService.setData(
                                    "currentUser",
                                    updateProfileData.data
                                );
                            });
                        this.localStorageService.setData(
                            "Profile_image",
                            updateProfileData.data.image_url
                        );
                        this.toastr.success(
                            updateProfileData.message,
                            "Success!"
                        );
                        this.confirmPhoneField = false; /// Confirm phone field
                        this.isDialogOpen = false;
                        this.isOTPForm = false;

                        this.getprofileDetails();
                    },
                    error => {
                        updateProfileData = error;
                        this.toastr.error(
                            updateProfileData.error.message,
                            "Failed!"
                        );
                    }
                );
        }
    }

    // Update super admin profile
    updateSuperAdminProfile(data) {
        this.focusFirstInvalidControlPlus(); //focus field
        if (data.valid) {
            let model: any = data.value;
            model.id = this.user_id;
            model.token = this.user_id;
            model.user_token = this.token;

            const formData = new FormData();
            if (this.fileToUpload) {
                formData.append(
                    "photo",
                    this.fileToUpload,
                    this.fileToUpload.name
                );
            }
            // Image validation
            if (this.imageValidate === true) {
                return;
            }

            Object.entries(model).forEach(([key, value]) => {
                formData.append(key, value as any);
            });

            let updateProfileData = <any>{};
            this.busy = this.userService
                .updateProfile(model, formData)
                .subscribe(
                    response => {
                        updateProfileData = response;

                        this.localStorageService.setData(
                            "currentUser",
                            updateProfileData.data
                        );

                        this.localStorageService.setData(
                            "Profile_image",
                            updateProfileData.data.image_url
                        );
                        this.toastr.success(
                            updateProfileData.message,
                            "Success!"
                        );
                        this.getprofileDetails();
                    },
                    error => {
                        updateProfileData = error;
                        this.toastr.error(
                            updateProfileData.error.message,
                            "Failed!"
                        );
                    }
                );
        }
    }
    // two factor enable and disable
    twoFactorEnableDisable(status) {
        const confirmationMessage = this.twofactorStatus
            ? "Are you sure you want to disable Two-factor Authentication?"
            : "Are you sure you want to enable Two-factor Authentication?";
        this.modal
            .confirm()
            .size("sm")
            .title("CasherPay")
            .body(confirmationMessage)
            .okBtn("Yes")
            .cancelBtn("No")
            .okBtnClass("btn btn-success")
            .cancelBtnClass("btn btn-warning")
            .open()
            .then(resultPromise => {
                resultPromise.result.then(
                    result => {
                        this.twofactorenable = true;
                        var data = {
                            token: this.token,
                            enableDisableStatus: status
                        };
                        let response_tfed = <any>{};
                        this.busy = this.userService
                            .twoFactorEnableDisable(data)
                            .subscribe(
                                response => {
                                    response_tfed = response;
                                    if (response_tfed.data.image) {
                                        this.toastr.success(
                                            response_tfed.message,
                                            "Success!"
                                        );
                                        this.imageurl =
                                            response_tfed.data.image;
                                        this.secret_key =
                                            response_tfed.data.secret;
                                        this.twofactorStatus = true;
                                    }
                                    if (response_tfed.data === false) {
                                        this.imageurl = "";
                                        this.secret_key = "";
                                        this.twofactorStatus = false;
                                        this.toastr.success(
                                            response_tfed.message,
                                            "Success!"
                                        );
                                    }
                                },
                                error => {
                                    response_tfed = error;
                                    this.toastr.error(
                                        response_tfed.error.message,
                                        "Failed!"
                                    );
                                }
                            );
                    },
                    () => {
                        console.log("Cancel");
                    }
                );
            });
    }

    //save Type it signature
    saveSignature(model) {
        this.val_type_signature = false;
        if (
            typeof model.type_signature === "undefined" ||
            model.type_signature === null ||
            model.type_signature === ""
        ) {
            this.val_type_signature = true;
            return false;
        }
        model.signature = model.type_signature;
        model.type_signature = "";
        model.user_token = this.token;
        model.token = this.user_id;
        model.id = this.user_id;
        let response_save_bank_details = <any>{};
        this.busy = this.userService.saveBankDetail(model).subscribe(
            response => {
                response_save_bank_details = response;
                this.toastr.success(
                    response_save_bank_details.message,
                    "Success!"
                );
                this.show_edit_signature = true;
                this.hide_signature_tab = false;
                this.getprofileDetails();
            },
            error => {
                response_save_bank_details = error;
                this.toastr.error(
                    response_save_bank_details.error.message,
                    "Failed!"
                );
            }
        );
    }

    // save Draw it Signature
    onSaveHandler() {
        let data = this.signaturePad.toDataURL();
        if (this.signaturePad.isEmpty()) {
            this.signature_validation = true;
        } else {
            this.signature_validation = false;
        }
        // if(this.signaturePad.signaturePad._isEmpty){
        //   this.signature_validation = true;
        // } else{
        //   this.signature_validation = false;
        // }
        if (!this.signature_submit) {
            return;
        }

        if (data.length === 1054) {
            this.signature_validation = true;
            return false;
        }
        this.profileBankDetails.signature = data;
        this.profileBankDetails.user_token = this.token;
        this.profileBankDetails.token = this.user_id;
        this.profileBankDetails.id = this.user_id;
        let response_save_signature = <any>{};
        this.busy = this.userService
            .saveBankDetail(this.profileBankDetails)
            .subscribe(
                response => {
                    response_save_signature = response;
                    this.toastr.success(
                        response_save_signature.message,
                        "Success!"
                    );
                    this.show_edit_signature = true;
                    this.hide_signature_tab = false;
                    this.getprofileDetails();
                },
                error => {
                    response_save_signature = error;
                    this.toastr.error(
                        response_save_signature.error.message,
                        "Failed!"
                    );
                }
            );
    }

    // edit signature
    editSignature() {
        this.signature_clear = false;
        this.signature_submit = false;
        this.show_edit_signature = false;
        this.hide_signature_tab = true;
    }

    // save bank details
    saveBankDetails(model, is_delete: any) {
        this.validationAccountNumber = false;
        this.validationRoutingNumber = false;

        //  if(typeof model.routing_number === 'undefined'  || model.routing_number === null || model.routing_number === ''){
        //       this.validationRoutingNumber = true;
        //       return false;
        //   }
        //   if(typeof model.account_number === 'undefined'  || model.account_number === null || model.account_number === ''){
        //       this.validationAccountNumber = true;
        //       return false;
        //   }
        //   if(model.account_number.toString().length !== 16){
        //     this.validationAccountNumberLength = true;
        //     return false;
        //   }
        //   if(model.routing_number.toString().length !== 9){
        //     this.validationRoutingNo_Length = true;
        //     return false;
        //   }

        // if(this.profileBankDetails.signature){
        //   model.signature = this.profileBankDetails.signature;
        //   this.profileBankDetails.type_signature = '';
        // }
        // if(this.profileBankDetails.type_signature){
        //   model.signature = this.profileBankDetails.type_signature;
        //   this.profileBankDetails.signature = '';
        // }
        model.user_token = this.token;
        model.token = this.user_id;
        model.id = this.user_id;
        if (is_delete) {
            model.is_delete = is_delete;
        }

        let response_save = <any>{};
        this.busy = this.userService.saveBankDetail(model).subscribe(
            response => {
                response_save = response;
                this.show_edit_signature = true;
                this.hide_signature_tab = false;
                this.getprofileDetails();
                if (is_delete) {
                    this.toastr.success("Bank Detail Deleted", "Success!");
                    this.profileBankDetails.bank_name = "";
                    this.bankname = "";
                } else {
                    this.toastr.success(response_save.message, "Success!");
                }
            },
            error => {
                response_save = error;
                this.toastr.error(response_save.error.message, "Failed!");
            }
        );
    }
    // Update low cheque alert
    updateLowCheckAlert(model) {
        model.user_token = this.token;
        model.token = this.user_id;
        model.id = this.user_id;
        let response_alert = <any>{};
        this.busy = this.userService.updateLowCheckAlert(model).subscribe(
            response => {
                response_alert = response;
                this.toastr.success(response_alert.message, "Success!");
            },
            error => {
                response_alert = error;
                this.toastr.error(response_alert.error.message, "Failed!");
            }
        );
    }

    focusFirstInvalidControlPlus(): void {
        const firstElementWithErrors: HTMLElement = this.elementRef.nativeElement.querySelector(
            `form .ng-invalid`
        );
        if (firstElementWithErrors) {
            firstElementWithErrors.focus();
        }
    }
    // Invite merchant user
    inviteMerchantUser(data) {
        this.focusFirstInvalidControlPlus(); //focus field
        this.formTouched = true;
        if (data.valid) {
            let model: any = data.value;
            model.token = this.token;
            model.id = this.user_id;

            this.upermissions["Transactions"] = "yes";

            if (
                typeof model.user_permissions_PrintCheck === "undefined" ||
                model.user_permissions_PrintCheck === false
            ) {
                this.upermissions["PrintCheck"] = "no";
            }
            if (
                typeof model.user_permissions_CreateCheque === "undefined" ||
                model.user_permissions_CreateCheque === false
            ) {
                this.upermissions["CreateCheque"] = "no";
            }

            if (model.user_permissions_PrintCheck === true) {
                this.upermissions["PrintCheck"] = "yes";
            }
            if (model.user_permissions_CreateCheque === true) {
                this.upermissions["CreateCheque"] = "yes";
            }

            model.permissions = this.upermissions;

            let response_invite = <any>{};
            this.busy = this.userService.inviteMerchantUserAPI(model).subscribe(
                response => {
                    response_invite = response;
                    this.toastr.success(response_invite.message, "Success!");
                    this.getMerchantUsers();
                    this.dataNotFound = false;
                    this.iu.reset();
                    this.formTouched = false;
                },
                error => {
                    response_invite = error;
                    this.toastr.error(response_invite.error.message, "Failed!");
                }
            );
        }
    }

    // get user by merchant
    getMerchantUsers() {
        var data = {
            token: this.token,
            id: this.user_id
        };
        var url = this.router.url;
        let response_users = <any>{};
        this.busy = this.userService.getMerchantUsersAPI(data).subscribe(
            response => {
                response_users = response;
                this.merchantUsers = response_users.data;
                if (response_users.data.length === 0) {
                    this.TeamdataNotFound = response_users.message;
                }
            },
            error => {
                response_users = error;
                this.toastr.error(response_users.error.message, "Failed!");
            }
        );
    }
    // Delete Merchant User
    deleteMerchantUser(event, m_id) {
        let response_merchant = <any>{};
        event.stopPropagation();
        this.modal
            .confirm()
            .size("sm")
            .title("CasherPay")
            .body(
                `Are you sure to delete this merchant user.
              `
            )
            .okBtn("Yes")
            .cancelBtn("Cancel")
            .okBtnClass("btn btn-success")
            .cancelBtnClass("btn btn-warning")
            .open()
            .then(resultPromise => {
                resultPromise.result.then(
                    result => {
                        var data = {
                            token: this.token,
                            id: m_id,
                            status: "11"
                        };

                        this.echexpaymentService.deleteMerchant(data).subscribe(
                            response => {
                                response_merchant = response;
                                this.toastr.success(
                                    response_merchant.message,
                                    "Success!"
                                );
                                this.getMerchantUsers();
                            },
                            error => {
                                response_merchant = error;
                                this.toastr.error(
                                    response_merchant.error.message,
                                    "Failed!"
                                );
                            }
                        );
                    },
                    () => {
                        console.log("Cancel");
                    }
                );
            });
    }

    // Document List
    getDocument_List() {
        let data = {
            user_token: this.token,
            merchantId: this.merchantId
        };
        let responseData = <any>{};
        this.busy = this.userService.GetDocumentList(data).subscribe(
            response => {
                responseData = response;
                this.getDoc_List = responseData.data;
                if (responseData.data.length == 0) {
                    this.doc_dataNotFound = responseData.message;
                }
            },
            error => {
                responseData = error;
            }
        );
    }

    getInvoice_List() {
        let data = {
            user_token: this.token,
            merchantId: this.merchantId
        };
        let responseData = <any>{};
        this.busy = this.userService.GetRecurringInvoiceList(data).subscribe(
            response => {
                responseData = response;
                this.data = responseData.data;
                if (responseData.data.length == 0) {
                    this.invoiceDataNotFound = responseData.message;
                } else {
                    this.invoiceDataNotFound = false;
                }
            },
            error => {
                responseData = error;
            }
        );
    }

    EditDocumentId(files: FileList, editId: string) {
        if (files.length === 0) {
            return;
        }

        const allowedFileTypes = [
            "image/jpeg",
            "image/png",
            "text/csv", // CSV
            "image/webp",
            "application/msword", // DOC
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // DOCX
            "application/pdf",
            "application/vnd.ms-excel",
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" // Excel (XLSX)
        ];

        const file = files[0];
        if (!allowedFileTypes.includes(file.type)) {
            this.chequeerror_res =
                "Only files with the following extensions are allowed: jpg, png, csv, jpeg, webp, doc, docx, pdf, excel";
            setTimeout(() => {
                this.chequeerror_res = "";
            }, 8000); // Hide error message after 5 seconds
            return;
        }

        let data = {
            merchantId: this.merchantId,
            user_token: this.token
        };

        let filedata = {
            id: editId
        };

        const formData = new FormData();
        formData.append("document", file, file.name);

        Object.entries(filedata).forEach(([key, value]) => {
            formData.append(key, value as any);
        });

        let uploadlastmonthData = <any>{};
        this.busy = this.userService.EditDocument_id(data, formData).subscribe(
            response => {
                uploadlastmonthData = response;
                this.getDocument_List();
                this.toastr.success(uploadlastmonthData.message, "Success!");
            },
            error => {
                uploadlastmonthData = error;
                this.toastr.error(error.message, "Failed!");
            }
        );
    }

    // Open Plaid popup
    ConnectBank() {
        this.linkHandler.open();
    }

    // @ViewChild('submitButton') submitButton: ElementRef;
    moveNext(nextInput: HTMLInputElement, checkbox) {
        if (checkbox === 1) {
            this.focusFirstCheckbox();
        } else if (checkbox === 3) {
            const saveButton = document.getElementById(
                "submitOTP"
            ) as HTMLElement;
            if (saveButton) {
                saveButton.focus();
                saveButton.click();
            }
        } else if (checkbox === 12) {
            const saveButton = document.getElementById(
                "Send_otp"
            ) as HTMLElement;
            if (saveButton) {
                saveButton.focus();
                saveButton.click();
            }
        } else if (checkbox === 2) {
            const saveButton = document.getElementById(
                "submitButton"
            ) as HTMLElement;
            if (saveButton) {
                saveButton.focus();
                saveButton.click();
            }
        } else {
            nextInput && nextInput.focus();
        }
    }

    ngAfterViewInit() {
        this.scriptService
            .load("Plaid")
            .then(data => {
                this.loadPopUp();
            })
            .catch(error => console.log(error));
        setTimeout(() => {
            const businessNameElement = document.querySelector(
                "#Business_name"
            ) as HTMLInputElement;
            if (businessNameElement) {
                this.renderer.selectRootElement(businessNameElement).focus();
            }
        }, 0);
        if (this.role_id === "1" || this.role_id === "2") {
            setTimeout(() => {
                const businessNameElement = document.querySelector(
                    "#pfirst_name"
                ) as HTMLInputElement;
                if (businessNameElement) {
                    this.renderer
                        .selectRootElement(businessNameElement)
                        .focus();
                }
            }, 0);
        }
    }

    // loadPopUp
    loadPopUp() {
        let data = { user_token: this.token };
        let responseData = <any>{};
        this.busy = this.userService.ConectBankV2(data).subscribe(response => {
            responseData = response;
            this.plaid_link_token = responseData.data.link_token;
            this.linkHandler = Plaid.create({
                token: this.plaid_link_token,
                onSuccess: function(public_token, metadata) {
                    (document.getElementById(
                        "publictoken"
                    ) as HTMLInputElement).value = public_token;
                    var l = document.getElementById("submitToGetInfo");
                    l.click();
                },
                onExit: function(err, metadata) {
                    // The user exited the Link flow.
                    if (err != null) {
                    }
                }
            });
        });
    }

    // get info from Plaid
    getInfoFromPlaid() {
        var public_token = (document.getElementById(
            "publictoken"
        ) as HTMLInputElement).value;
        var data = {
            PlaidInfo: true,
            token: public_token,
            amount: 1
        };
        let responseData = <any>{};
        this.busy = this.echexpaymentService
            .getInfoFromPlaidApi(data)
            .subscribe(
                response => {
                    this.disable = true;
                    responseData = response;
                    this.profileBankDetails = responseData.data;
                    this.account_checking = responseData.data.account_checking;
                    this.routing_checking = responseData.data.routing_checking;
                    this.getRoutingInfo(responseData.data.routing_checking);
                },
                error => {
                    responseData = error;
                    this.account_checking = "";
                    this.routing_checking = "";
                    this.chequeerror_res = responseData.error.message;
                }
            );
    }

    // get routing info
    getRoutingInfo(routing_number) {
        if (routing_number.length >= 9) {
            let data = {
                user_token: this.token,
                token: this.user_id,
                id: this.user_id,
                routing_number: routing_number
            };
            let responseData = <any>{};
            this.userService.getRoutingInfoApi(data).subscribe(
                response => {
                    responseData = response;
                    this.chequeerror_res = "";
                    this.bankname = responseData.data.name;
                    this.profileBankDetails = responseData.data;
                    this.save_BankDetails(responseData.data);
                    this.getprofileDetails();
                },
                error => {
                    responseData = error;
                    this.account_checking = "";
                    this.routing_checking = "";
                    this.chequeerror_res = error.message;
                }
            );
        }
    }

    // save bank details
    save_BankDetails(data) {
        let model = <any>{};
        model.account_number = this.account_checking;
        model.routing_number = data.routing_number;
        model.bank_name = data.name;
        model.bank_address = data.address;
        model.user_token = this.token;
        model.token = this.user_id;
        model.id = this.user_id;
        let response_save = <any>{};
        this.busy = this.userService.saveBankDetailwithoutsign(model).subscribe(
            response => {
                response_save = response;
                this.toastr.success(response_save.message, "");
            },
            error => {
                response_save = error;
                this.chequeerror_res = error.message;
            }
        );
    }

    getDownloadUrl(fileUrl: string, extension: string): string {
        const filename = `downloaded-file${extension}`;
        return `${fileUrl}?filename=${encodeURIComponent(filename)}`;
    }

    // force download file
    downloadFile(url, name) {
        fetch(url)
            .then(resp => resp.blob())
            .then(blob => {
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.style.display = "none";
                a.href = url;
                // the filename you want
                a.download = name;
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
            })
            .catch(() => alert("An error sorry"));
    }

    //Recurring
    getAllTransaction() {
        var data = {
            user_token: this.token,
            token: this.user_id,
            _id: this.user_id,
            recurrent: 1
        };

        let responseData = <any>{};
        this.busy = this.echexpaymentService
            .getAllTransactionData(data)
            .subscribe(
                response => {
                    responseData = response;
                    var checkAmount;
                    checkAmount = 0;
                    this.data = responseData.data;
                    if (this.data.length == 0) {
                        this.dataNotFound = responseData.message;
                    }
                    this.data.forEach(function(eachObj) {
                        checkAmount =
                            parseFloat(checkAmount) +
                            parseFloat(eachObj.cheque_amount);
                    });
                },
                error => {
                    responseData = error;
                    this.toastr.error(responseData.error.message, "Failed!");
                }
            );
    }

    removeRecurring(id: any) {
        event.stopPropagation();
        this.modal
            .confirm()
            .size("sm")
            .title("CasherPay")
            .body(`Are you sure to delete this Recurring.`)
            .okBtn("Yes")
            .cancelBtn("Cancel")
            .okBtnClass("btn btn-success")
            .cancelBtnClass("btn btn-warning")
            .open()
            .then(resultPromise => {
                resultPromise.result.then(
                    result => {
                        var data = {
                            token: this.user_id,
                            user_token: this.token,
                            _id: id,
                            merchant_id: this.user_id
                        };
                        let responseData = <any>{};
                        this.busy = this.echexpaymentService
                            .DeleteRecurring(data)
                            .subscribe(
                                response => {
                                    responseData = response;
                                    this.toastr.success(
                                        responseData.message,
                                        "Success!"
                                    );
                                    this.getAllTransaction();
                                },
                                error => {
                                    responseData = error;
                                    this.toastr.error(
                                        responseData.error.message,
                                        "Failed!"
                                    );
                                }
                            );
                    },
                    () => {
                        console.log("Cancel");
                    }
                );
            });
    }

    removeInvoiceRecurring(id: any) {
        event.stopPropagation();
        this.modal
            .confirm()
            .size("sm")
            .title("CasherPay")
            .body(`Are you sure to delete this Invoice Recurring.`)
            .okBtn("Yes")
            .cancelBtn("Cancel")
            .okBtnClass("btn btn-success")
            .cancelBtnClass("btn btn-warning")
            .open()
            .then(resultPromise => {
                resultPromise.result.then(
                    result => {
                        var data = {
                            token: this.user_id,
                            user_token: this.token,
                            _id: id,
                            merchant_id: this.user_id
                        };
                        let responseData = <any>{};
                        this.busy = this.echexpaymentService
                            .DeleteInvoiceRecurring(data)
                            .subscribe(
                                response => {
                                    responseData = response;
                                    this.toastr.success(
                                        responseData.message,
                                        "Success!"
                                    );
                                    this.getInvoice_List();
                                },
                                error => {
                                    responseData = error;
                                    this.toastr.error(
                                        responseData.error.message,
                                        "Failed!"
                                    );
                                }
                            );
                    },
                    () => {
                        console.log("Cancel");
                    }
                );
            });
    }

    // + country code in phone field
    validateInput(event: any): void {
        const inputValue = event.target.value;
        const firstChar = inputValue.charAt(0);
        const keyCode = event.keyCode || event.which;

        // Allow only numeric digits (0-9) and backspace/delete keys
        if (keyCode < 48 || keyCode > 57) {
            event.preventDefault();
        }

        // Limit the input length to 4 characters
        if (inputValue.length >= 4 && keyCode !== 8 && keyCode !== 46) {
            event.preventDefault();
        }

        // Make the first character read-only "+"
        if (inputValue.length === 0) {
            event.target.value = "+";
        }
    }
    validateNumberInput(event: any) {
        const allowedKeys = ["Backspace", "Delete", "Tab", "Escape", "Enter"];
        const allowedKeyCodes = [46, 8, 9, 27, 13, 37, 39]; // Backspace, Delete, Tab, Escape, Enter

        if (
            allowedKeys.indexOf(event.key) !== -1 ||
            allowedKeyCodes.indexOf(event.keyCode) !== -1
        ) {
            // Allow the default behavior for certain keys
            return;
        }

        if (!/^\d+$/.test(event.key)) {
            // Prevent input if it's not a digit
            event.preventDefault();
        }
    }
    handleInputChange(event: any): void {
        const inputValue = event.target.value;
        const firstChar = inputValue.charAt(0);

        // If the input value is empty or contains non-numeric characters, reset the input value with "+"
        if (!inputValue || !/^\+\d*$/.test(inputValue)) {
            event.target.value = "+";
        }
    }
    // End + country code in phone field

    NameCharacterLimit(event: any, fieldName: string, max_length: number) {
        const maxTextLength = max_length; // Maximum text length of 20 characters
        const inputChar = event.key;
        const allowedKeys = ["Backspace", "Delete", "Tab", "Escape", "Enter"];
        const allowedKeyCodes = [46, 8, 9, 27, 13, 37, 39]; // Backspace, Delete, Tab, Escape, Enter

        if (
            allowedKeys.indexOf(event.key) !== -1 ||
            allowedKeyCodes.indexOf(event.keyCode) !== -1
        ) {
            return;
        }

        const inputValue = event.target.value;

        if (inputValue.length >= maxTextLength) {
            if (allowedKeys.indexOf(inputChar) === -1) {
                this.NamecharacterLimitReached[fieldName] = true; // Set the validation flag to true to show the warning message
                setTimeout(() => {
                    this.NamecharacterLimitReached[fieldName] = false; // Hide the warning message after 3 seconds
                }, 3000);
                event.preventDefault(); // Prevent entering the exceeded character
            }
        }
    }

    isNameLimitReached(fieldName: string): boolean {
        return this.NamecharacterLimitReached[fieldName];
    }

    opeDialog() {
        this.isDialogOpen = !this.isDialogOpen;
        setTimeout(() => {
            this.renderer.selectRootElement("#FocusCountrycode").focus();
        }, 600);
    }

    VerifyPhoneNumber(verifyphonedata, action: string) {
        this.focusFirstInvalidControlPlus(); //focus field
        if (verifyphonedata.valid) {
            let phoneNumber = verifyphonedata.value.phone1;
            let formattedPhoneNumber =
                phoneNumber && phoneNumber.replace(/\D/g, "");
            if (action === "send_otp") {
                let data = {
                    otp_method: "sms",
                    confirm_phone_number:
                        verifyphonedata.value.country_code +
                        formattedPhoneNumber,
                    user_token: this.token
                };
                let registerData = <any>{};
                this.busy = this.userService.UpdatePhone_Number(data).subscribe(
                    response => {
                        registerData = response;

                        if (registerData.status_code === 500) {
                            this.PhoneOtpcheck = registerData.message;
                        } else {
                            this.toastr.success(
                                registerData.message,
                                "Success!"
                            );
                            this.PhoneOtpcheck = "";
                            this.isOTPForm = true;
                            setTimeout(() => {
                                this.renderer
                                    .selectRootElement("#otpFocus")
                                    .focus();
                            }, 600);
                        }
                    },
                    error => {
                        registerData = error;
                        this.PhoneOtpcheck = error.message;
                    }
                );
                // } else if(action === 'updateNumber'){
                //   console.log( this.profile, action)
                //     this.updateProfile(this.profile)
            } else {
                if (
                    verifyphonedata.value.otp_text &&
                    verifyphonedata.value.otp_text.length >= 4 &&
                    verifyphonedata.value.otp_text.length <= 6
                ) {
                    this.CheckOtp = false;
                } else {
                    this.CheckOtp = true;
                    const saveButton = document.getElementById(
                        "otpFocus"
                    ) as HTMLElement;
                    if (saveButton) {
                        saveButton.focus();
                        saveButton.click();
                    }
                    return;
                }

                this.CheckOtp = false;
                let data = {
                    otp_text: verifyphonedata.value.otp_text,
                    confirm_phone_number:
                        verifyphonedata.value.country_code +
                        formattedPhoneNumber,
                    user_token: this.token
                };
                let registerData = <any>{};
                this.busy = this.userService
                    .UpdatePhone_NumberOTP(data)
                    .subscribe(
                        response => {
                            registerData = response;
                            if (registerData.status_code === 500) {
                                this.PhoneOtpcheck = registerData.message;
                                this.isDialogOpen = true;
                            } else {
                                this.toastr.success(
                                    registerData.message,
                                    "Success!"
                                );
                                this.PhoneOtpcheck = "";
                                this.profile.phone =
                                    verifyphonedata.value.phone1;
                                this.profile.country_code =
                                    verifyphonedata.value.country_code;
                                this.Update_PhoneNumber(this.profile);
                                this.isOTPForm = false;
                                // this.confirmPhoneField = true;
                                this.isDialogOpen = false;
                            }
                        },
                        error => {
                            registerData = error;
                            this.PhoneOtpcheck = error.message;
                            this.isDialogOpen = true;
                        }
                    );
            }
        }
    }

    updateOtp(inputElement: HTMLInputElement) {
        const inputValue = inputElement.value.trim(); // Remove leading/trailing whitespace
        if (inputValue.length >= 4 && inputValue.length <= 6) {
            this.CheckOtp = false;
        } else {
            this.CheckOtp = true;
        }
    }

    //update profile
    Update_PhoneNumber(data) {
        let model: any = data;
        model.id = this.user_id;
        model.token = this.user_id;
        model.user_token = this.token;

        const formData = new FormData();
        if (this.fileToUpload) {
            formData.append("photo", this.fileToUpload, this.fileToUpload.name);
        }
        // Image validation
        if (this.imageValidate === true) {
            return;
        }
        if (this.vendorimgValidate === true) {
            return;
        }
        if (this.vendorlogoUpload) {
            formData.append(
                "vendor_logo",
                this.vendorlogoUpload,
                this.vendorlogoUpload.name
            );
        }

        Object.entries(model).forEach(([key, value]) => {
            formData.append(key, value as any);
        });

        let updateProfileData = <any>{};
        this.busy = this.userService.updateProfile(model, formData).subscribe(
            response => {
                updateProfileData = response;

                let data = { data: { user_token: this.token } };
                this.userService.getAuthUser(data).subscribe(response => {
                    updateProfileData = response;
                    this.localStorageService.setData(
                        "currentUser",
                        updateProfileData.data
                    );
                });
                this.localStorageService.setData(
                    "Profile_image",
                    updateProfileData.data.image_url
                );
                setTimeout(() => {
                    this.toastr.success(
                        "Phone number updated successfully.",
                        "Success!"
                    );
                }, 6000);
                this.confirmPhoneField = false; /// Confirm phone field
                this.isDialogOpen = false;
                this.isOTPForm = false;

                this.getprofileDetails();
            },
            error => {
                updateProfileData = error;
                this.toastr.error(updateProfileData.error.message, "Failed!");
            }
        );
    }

    preventLetterE(event: KeyboardEvent) {
        if (event.key === "e") {
            event.preventDefault();
        }
    }

    onChangeDirectDeposit(deposit_type, change_type) {
        if(change_type == 2) {
            this.automaticTypeOption = deposit_type;
        } else {
            this.directDepositOption = deposit_type; 
        }

        if(deposit_type == 'automatic' && change_type == 1) {
            this.showAutomaticOption = true;
            this.automaticTypeOption = 'standard_ach';
        } else if(deposit_type == 'manual' && change_type == 1) {
            this.showAutomaticOption = false;
        }
    }

    updateDirectDepositSetting() {
        let updateDirectDepositSettings = <any>{};
        let data: any = {};
        data.id = this.user_id;
        data.user_token = this.token;
        data.deposit_type = this.directDepositOption;
        data.deposit_type_settings = this.automaticTypeOption;

        this.busy = this.userService.updateDirectDeposit(data).subscribe(
            response => {
                updateDirectDepositSettings = response;

                var currentUserToken = this.localStorageService.getData("currentUserToken");
                var currentUser = this.localStorageService.getData("currentUser");
                currentUserToken.data.settings = updateDirectDepositSettings.data;
                currentUser.settings = updateDirectDepositSettings.data;
                this.localStorageService.setData(
                    "currentUserToken",
                    currentUserToken
                );

                this.localStorageService.setData(
                    "currentUser",
                    currentUser
                );

                setTimeout(() => {
                    this.toastr.success(
                        "Direct Deposit settings updated successfully!.",
                        "Success!"
                    );
                }, 1000);
            },
            error => {
                updateDirectDepositSettings = error;
                this.toastr.error(updateDirectDepositSettings.error.message, "Failed!");
            }
        );
    }
}



// WEBPACK FOOTER //
// C:/xampp/htdocs/projects/angular.casherpay.stgnew/angular.casherpay/src/app/profile/profile.component.ts